import React from 'react'

const SearchResultPage = () => {
  return (
    <div>SearchResultPage</div>
  )
}

export default SearchResultPage